// extracted by mini-css-extract-plugin
module.exports = {"uploadDisclaimer":"HA8Q3AZC","styledAnchor":"QjNUzGqM"};